// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1l6a-","title":"styles_title__1kmLz","form":"styles_form__3neuR","button":"styles_button__H4Lge","buttonLoading":"styles_buttonLoading__2M9s7"};